// extracted by mini-css-extract-plugin
module.exports = {"title":"title___39yxA","dek":"dek___-M8os","featuredAuthor":"featuredAuthor___1v9It"};